// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { SportEntity } from '../../states/entities/sports';
import { MatchTitleAllowedSportIdsAnimation } from '../../types/match';
import { type SportId } from '../../types/sports';
import MatchSubTitle from '../MatchSubTitle';
import MatchTitle from '../MatchTitle';
import ScoreboardPsoScore from '../ScoreboardPsoScore';
import ScoreboardRowContainer from '../ScoreboardRow/ScoreboardRowContainer';

export const name = 'full-match-title';

const Wrapper = styled.div`
  padding: 0.4em 0em;
`;

const StyledMatchTitle = styled(MatchTitle)``;

const ScoreboardWrapper = styled.div`
  padding-left: ${({ $pad }) => ($pad ? '3em' : '0.5em')};
  padding-right: 3em;
`;

const StyledPsoScore = styled(ScoreboardPsoScore)`
  display: table;
  margin: 0.7em auto 0.5em;
`;

const StyledMatchSubTitle = styled(MatchSubTitle)`
  ${({ $isMatchCard }) => {
    if ($isMatchCard) {
      return css`
        padding: 0 4em;
      `;
    }
  }}
`;

type MatchFullTitleProps = {
  className?: string;
  competitor1Name: string;
  competitor2Name: string;
  competitor1NbRedCards?: number;
  competitor2NbRedCards?: number;
  score1?: number;
  score2?: number;
  flag1: string | null;
  flag2: string | null;
  subTitle?: string;
  flagId?: number;
  matchId: number;
  sportId?: SportId;
  isLive: boolean | null;
  title?: string;
  padScoreboard: boolean | null;
  isMatchCard?: boolean;
  psoScore?: Array<string>;
  subtitleRedirection?: string;
};

const MatchFullTitle = ({
  className,
  competitor1Name,
  competitor2Name,
  competitor1NbRedCards = 0,
  competitor2NbRedCards = 0,
  score1,
  score2,
  flag1,
  flag2,
  subTitle,
  flagId,
  matchId,
  sportId,
  padScoreboard,
  isLive,
  title,
  isMatchCard,
  psoScore,
  subtitleRedirection,
}: MatchFullTitleProps) => {
  const fullClassName = useMemo(() => (className ? `${className} ${name}` : name), [className]);

  const titleHeader = useMemo(() => {
    if (isLive && SportEntity.isSetSport(sportId)) {
      return (
        <ScoreboardWrapper $pad={padScoreboard}>
          <ScoreboardRowContainer matchId={matchId} />
        </ScoreboardWrapper>
      );
    }

    return (
      <StyledMatchTitle
        key={matchId}
        competitor1Name={competitor1Name}
        competitor2Name={competitor2Name}
        competitor1NbRedCards={competitor1NbRedCards}
        competitor2NbRedCards={competitor2NbRedCards}
        score1={score1}
        score2={score2}
        flag1={flag1}
        flag2={flag2}
        title={title}
        animatedScore={MatchTitleAllowedSportIdsAnimation.includes(sportId)}
      />
    );
  }, [
    isLive,
    sportId,
    competitor1Name,
    competitor1NbRedCards,
    competitor2NbRedCards,
    competitor2Name,
    score1,
    score2,
    flag1,
    flag2,
    title,
    padScoreboard,
    matchId,
  ]);

  return (
    <Wrapper className={fullClassName}>
      {titleHeader}
      {psoScore ? <StyledPsoScore score1={psoScore[0]} score2={psoScore[1]} /> : null}
      <StyledMatchSubTitle
        subTitle={subTitle}
        flagId={flagId}
        $isMatchCard={isMatchCard}
        redirection={subtitleRedirection}
      />
    </Wrapper>
  );
};

export default MatchFullTitle;
